;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import { setRedirectCookie } from '@/lib/helpers/utils';
import { clearProfileFilledAt } from '@/lib/profile';
import { canAccessStorage } from '@/lib/helpers/is-storage-available';

// Clears the locally cached profile without touching sessionStorage. Flows that
// log out via a server-side redirect (e.g. Passport activation's "Use a
// Different Email") must drop the stale profile, but must preserve in-progress
// sessionStorage like the passport activation token.
export const clearLocalProfile = () => {
  if (canAccessStorage('localStorage')) {
    localStorage.removeItem('profile');
    // Clear all of the recommended shows data from localStorage
    Object.keys(localStorage)
      .filter((key) => key.startsWith('recommendedShows'))
      .forEach((key) => localStorage.removeItem(key));
    }
  clearProfileFilledAt()
}

export const handleSignOut = () => {
  setRedirectCookie();
  if (canAccessStorage('sessionStorage')) {
    sessionStorage.clear();
  }
  clearLocalProfile();
}
